const en = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.algorithms': 'Algorithms',
  'nav.charts': 'Charts',
  'nav.brokers': 'Brokers',
  'nav.tradingHistory': 'Trading History',
  'nav.paperTrading': 'Paper Trading',
  'nav.portfolio': 'Portfolio',
  'nav.settings': 'Settings',
  'nav.screener': 'Screener',
  'nav.marketplace': 'Marketplace',
  'nav.journal': 'Journal',

  // Common actions
  'action.save': 'Save',
  'action.cancel': 'Cancel',
  'action.delete': 'Delete',
  'action.edit': 'Edit',
  'action.create': 'Create',
  'action.start': 'Start',
  'action.stop': 'Stop',
  'action.refresh': 'Refresh',
  'action.export': 'Export',
  'action.import': 'Import',
  'action.search': 'Search',
  'action.filter': 'Filter',
  'action.back': 'Back',
  'action.next': 'Next',
  'action.confirm': 'Confirm',
  'action.close': 'Close',

  // Trading terms
  'trading.buy': 'Buy',
  'trading.sell': 'Sell',
  'trading.long': 'Long',
  'trading.short': 'Short',
  'trading.profit': 'Profit',
  'trading.loss': 'Loss',
  'trading.pnl': 'P&L',
  'trading.winRate': 'Win Rate',
  'trading.totalTrades': 'Total Trades',
  'trading.openPositions': 'Open Positions',
  'trading.balance': 'Balance',
  'trading.symbol': 'Symbol',
  'trading.quantity': 'Quantity',
  'trading.price': 'Price',
  'trading.entryPrice': 'Entry Price',
  'trading.exitPrice': 'Exit Price',
  'trading.stopLoss': 'Stop Loss',
  'trading.takeProfit': 'Take Profit',
  'trading.status': 'Status',

  // Status labels
  'status.active': 'Active',
  'status.paused': 'Paused',
  'status.stopped': 'Stopped',
  'status.draft': 'Draft',
  'status.completed': 'Completed',
  'status.running': 'Running',
  'status.failed': 'Failed',
  'status.pending': 'Pending',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.todayPnl': "Today's P&L",
  'dashboard.totalBalance': 'Total Balance',
  'dashboard.activeAlgorithms': 'Active Algorithms',
  'dashboard.recentTrades': 'Recent Trades',

  // Settings
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.notifications': 'Notifications',

  // Empty states
  'empty.noAlgorithms': 'No algorithms yet',
  'empty.noTrades': 'No trades yet',
  'empty.noData': 'No data available'
}

export default en
